import { zhCN } from "@mui/material/locale";
import zhMessages from "../locales/zh-Hans.json";

const ZhLan = {
  messages: {
    ...zhMessages,
  },
  muiLocale: zhCN,
  locale: "zh-Hans-CN",
};
export default ZhLan;
